module.exports = __webpack_public_path__ + "static/img/G1.968f362.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mjhl/G1.png
// module id = 2QaC
// module chunks = 0